<app-projects-price-approval-table [projects]="tableProjects"
                    (headerSortBtnClicked)="onTableSortBtnClicked( $event )"
                    (projectTableRowActionsMenuClicked)="onProjectTableRowActionsMenuClicked( $event )"
                    [isProcessedModeUsed]="isProcessedModeUsed">

</app-projects-price-approval-table>

